import React from 'react'
import AboutUs from "../components/AboutUs"
import Footer from "../components/Footer"
import bg from "../images/IMG_0095.jpg";
import gym from "../images/svg/gym.svg"
import room_service from "../images/svg/room_service.svg"
import wifi from "../images/svg/wi-fi.svg"
import food from "../images/svg/food.svg"
import car from "../images/svg/car.svg"
import pool from "../images/svg/pool.svg"
import Content from '../components/Content'
import Button from '../components/Button'
import Nav from '../components/Nav'
import wall from "../images/wall.JPG"
import hotel_diagonal from "../images/hotel_diagonal.JPG"
import outside from "../images/outside.JPG"
import hotel from "../images/hotel.JPG"
import CustomerReviews from "../components/carousels/CustomerReviews"

const About = () => {
  const SERVICES_OPTIONS=[{src:room_service,title:"Room Service",content:"Room tincidunt nis ace park norttito sit ametspace, mus nellentesque habitant."},
{src:wifi,title:"Fibre Internet",content:"Room tincidunt nis ace park norttito sit ametspace, mus nellentesque habitant."},
{src:food,title:"Awesome Food",content:"Eat tincidunt nisa ace park norttito sit amet space, mus nellentesque habitant"},
{src:pool,title:"Private Pool",content:"Room tincidunt nis ace park norttito sit amet space, mus nellentesque habitant."},
{src:gym,title:"Gym Access",content:"Wifi tincidunt nis ace park norttito sit amet space,mus nellentesque habitant."},
{src:car,title:"Parking Space",content:"Eat tincidunt nisa ace park norttito sit amet space, mus nellentesque habitant"}]
  return (
    <div>
       
        <div className="h-3/4 bg bg-cover">
        <div className="h-full z-10 overlay">
          <Nav/>
          <div className="container landing mx-auto z-10 text-center text-white">
            <p className="text-4xl">ABOUT US</p>
          </div>
          </div>
          </div>
          <AboutUs/>
          <div className="md:relative sm:relative w-full md:h-1/2 grid grid-flow-row">
            <img className="bg-cover" src={hotel} alt="bg"/>
            <div className="md:absolute md:bottom-0 sm:absolute sm:bottom-0 w-full">
            <div className=" overlay z-10 container  w-full md:w-3/4 mx-auto text-white text-center  p-7">
              <p className="text-4xl p-5">Welcome to Hotel Sarvoday</p>
              <p className="text-xl font-semibold p-3">lorem Ipsum lorem lorem ipsum dolor sit</p>
              <div className="p-5"><Button label="BOOK NOW" isColour={true} /></div></div>
            </div>
          </div>
          <div className="m-3 p-5 w-3/4 gap-4 container mx-auto grid md:grid-cols-2 grid-cols-1 md:grid-flow-col grid-flow-row">
            <div><div className="md:text-6xl text-3xl p-5">Lorem ipsum
dolor sit amet, consectetur</div>
<img src={wall} alt="bg"/></div>
<div>
 <img src={hotel_diagonal} alt="bg"/>
 <div className="text-lg p-5">Lorem ipsum
dolor sit amet, consectetur.Lorem ipsum
dolor sit amet, consectetur.Lorem ipsum
dolor sit amet, consectetur.Lorem ipsum
dolor sit amet, consectetur</div><div className="pl-5">
<Button isColour={true} label='BOOK NOW'/></div>
</div>
          </div>
          <div className="m-3 p-5 w-3/4 container mx-auto">
            <div className="text-center text-2xl">History and Culture</div>
           <div className="text-center text-lg"> Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt</div>
            <div className="m-3 p-5 w-3/4 text-black container mx-auto grid md:grid-cols-2 grid-cols-1 md:grid-flow-col grid-flow-row gap-5">
              <div className="text-lg">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt.Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt.Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt.</div>
             <div className="text-lg">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt.Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt.Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt.</div>
            </div>
          </div>
          <img src={outside} alt="bg"/>
          <div className="container py-10 mx-auto md:w-1/2 w-full text-center"><Content isColor={true} title="O U R  S E R V I C E S" subtitle="Hotel Facilities"/>
            
              </div>
<div className="m-3 p-5 lg:w-4/5 w-full container mx-auto grid grid-cols-1 md:grid-cols-3 gap-6">
              {SERVICES_OPTIONS.map((cards,i)=>{
               return(
              //  <Card key={i} src={card.src} subtitle={card.title} content={card.content}/>
<div key={i} className="container p-5 mx-auto border-2 text-center border-gray-200">
        <img className="bg-cover mx-auto p-10 h-40 w-40" src={cards.src}  alt="icon"/>
        <Content isColor="black" subtitle={ cards.title} content={ cards.content}/>
    </div>
    )})}</div>
    <div className="w-full container m-auto relative">
      <img className="bg-cover w-full" src={bg} alt="bg"/>
      <div className="container w-full md:absolute md:top-0 place-self-center md:p-10">
      <p className="text-center text-4xl p-10 md:text-white text-black font-semibold">Customer Reviews</p>
    <div className="md:place-self-center"><CustomerReviews/></div></div></div>


          <Footer/>
          </div>
  )
}
export default About